/* Divine Importers refresh: saved list, home slider, product gallery, listing filters. No dependencies. */
(function () {
  var KEY = 'dv-saved';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} paint(); }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function toggle(el) {
    var h = el.getAttribute('data-handle'), list = load();
    if (has(h)) { list = list.filter(function (x) { return x.h !== h; }); }
    else { list.push({ h: h, t: el.getAttribute('data-title'), v: el.getAttribute('data-vendor'), c: el.getAttribute('data-code'), k: el.getAttribute('data-pack') || '', i: el.getAttribute('data-img') }); }
    store(list);
  }
  function paint() {
    var list = load();
    document.querySelectorAll('[data-dv-save]').forEach(function (el) {
      var on = list.some(function (x) { return x.h === el.getAttribute('data-handle'); });
      el.classList.toggle('on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = el.querySelector('[data-label]');
      if (lab) lab.textContent = on ? 'Saved to your list' : 'Save to your list';
    });
    document.querySelectorAll('.dv-saved-link').forEach(function (a) { a.classList.toggle('on', list.length > 0); });
    var page = document.querySelector('[data-dv-saved-page]');
    if (page) renderSaved(page, list);
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderSaved(page, list) {
    var grid = page.querySelector('[data-grid]'), empty = page.querySelector('[data-empty]'), acts = page.querySelector('[data-acts]');
    empty.hidden = list.length > 0; acts.hidden = list.length === 0;
    grid.innerHTML = list.map(function (x) {
      return '<div class="lc"><a class="pc" href="/products/' + esc(x.h) + '"><span class="im">' + (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy">' : '') + '</span>' +
        '<span class="pr">' + esc(x.v) + '</span><span class="t">' + esc(x.t) + '</span>' + (x.k ? '<span class="m pk">' + esc(x.k) + '</span>' : '') + (x.c ? '<span class="cd">Code ' + esc(x.c) + '</span>' : '') + '</a>' +
        '<button class="sv on" type="button" data-dv-save data-handle="' + esc(x.h) + '" aria-pressed="true" aria-label="Remove ' + esc(x.t) + '">' + heart + '</button></div>';
    }).join('');
    var mail = page.querySelector('[data-mail]');
    if (mail) {
      var body = 'Hello,\n\nPlease could you give me prices for the following:\n\n' + list.map(function (x) { return '- ' + x.t + (x.v ? ', ' + x.v : '') + (x.k ? ', ' + x.k : '') + (x.c ? ' (code ' + x.c + ')' : ''); }).join('\n') + '\n\nThank you,\n';
      mail.href = 'mailto:' + mail.getAttribute('data-to') + '?subject=' + encodeURIComponent('Price enquiry from the website') + '&body=' + encodeURIComponent(body);
    }
  }
  var heart = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';

  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-dv-save]');
    if (s) { e.preventDefault(); toggle(s); return; }
    var clr = e.target.closest('[data-dv-clear-saved]');
    if (clr) { e.preventDefault(); store([]); return; }
    // listing filter dropdowns
    var dd = e.target.closest('[data-dd]');
    if (dd) {
      var id = dd.getAttribute('data-dd'), panel = document.getElementById(id), open = panel && panel.hidden;
      document.querySelectorAll('.fb .panel').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('[data-dd]').forEach(function (b) { b.classList.remove('isopen'); b.setAttribute('aria-expanded', 'false'); });
      if (panel && open) { panel.hidden = false; dd.classList.add('isopen'); dd.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if (!e.target.closest('.fb .panel')) {
      document.querySelectorAll('.fb .panel').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('[data-dd]').forEach(function (b) { b.classList.remove('isopen'); });
    }
    // product gallery thumbnails
    var th = e.target.closest('[data-thumb]');
    if (th) {
      e.preventDefault();
      var g = th.closest('.gal'), main = g.querySelector('.main img');
      main.src = th.getAttribute('data-thumb'); main.srcset = '';
      main.classList.toggle('photo', th.hasAttribute('data-photo'));
      g.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('on', t === th); });
    }
    // home slider
    var sl = e.target.closest('[data-slide-go]');
    if (sl) { var h = sl.closest('[data-slider]'); go(h, sl.getAttribute('data-slide-go')); }
  });
  // filter checkboxes submit straight away
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dv-sort]')) { e.target.form.submit(); return; }
    var o = e.target.closest('.opt'); if (o) o.classList.toggle('on', e.target.checked);
  });
  // "Show more" on listings: fetch the next page and append it
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-dv-more]'); if (!m) return;
    e.preventDefault(); m.textContent = 'Loading…';
    fetch(m.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.querySelector('[data-dv-grid]'), ng = doc.querySelector('[data-dv-grid]');
      if (grid && ng) ng.querySelectorAll(':scope > .lc').forEach(function (c) { grid.appendChild(c); });
      var foot = document.querySelector('[data-dv-foot]'), nf = doc.querySelector('[data-dv-foot]');
      if (foot && nf) foot.innerHTML = nf.innerHTML;
      paint();
    }).catch(function () { window.location = m.href; });
  });
  function go(h, dir) {
    var slides = h.querySelectorAll('.slide'), n = slides.length, i = 0;
    slides.forEach(function (s, k) { if (!s.hidden) i = k; });
    var j = dir === 'next' ? (i + 1) % n : dir === 'prev' ? (i - 1 + n) % n : parseInt(dir, 10);
    slides.forEach(function (s, k) { s.hidden = k !== j; });
    h.querySelectorAll('[data-slide-go].dot').forEach(function (d, k) { d.classList.toggle('on', k === j); d.setAttribute('aria-current', k === j ? 'true' : 'false'); });
    var lbl = h.querySelector('[data-next-label]');
    if (lbl) lbl.textContent = 'Next: ' + (slides[(j + 1) % n].getAttribute('data-label') || '');
  }
  document.addEventListener('DOMContentLoaded', paint);
  if (document.readyState !== 'loading') paint();
})();
/* New & Popular chips */
(function () {
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-np-chip]'); if (!c) return;
    var root = c.closest('[data-np]'), v = c.getAttribute('data-np-chip'), shown = 0;
    root.querySelectorAll('[data-np-chip]').forEach(function (b) { b.classList.toggle('on', b === c); });
    root.querySelectorAll('[data-dept]').forEach(function (g) { var ok = v === 'all' || g.getAttribute('data-dept') === v; g.hidden = !ok; if (ok) shown++; });
    var em = root.querySelector('[data-np-empty]'); if (em) em.hidden = shown > 0;
  });

  /* Phone menu panel */
  (function () {
    var panel = document.getElementById('dv-menu'); if (!panel) return;
    var btn = document.querySelector('[data-dv-menu]');
    function open() { panel.hidden = false; document.body.style.overflow = 'hidden'; if (btn) btn.setAttribute('aria-expanded', 'true'); var c = panel.querySelector('[data-dv-menu-close]'); if (c) c.focus(); }
    function close() { panel.hidden = true; document.body.style.overflow = ''; if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); } }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dv-menu]')) { e.preventDefault(); open(); return; }
      if (panel.hidden) return;
      if (e.target.closest('[data-dv-menu-close]') || e.target === panel) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    window.addEventListener('resize', function () { if (!panel.hidden && window.innerWidth > 760) close(); });
  })();

  /* 404 search box (kept free of the search app) and "Show all" on article products */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-dv-go]'); if (!f) return;
    e.preventDefault(); var q = (f.querySelector('input[name="q"]') || {}).value || '';
    window.location.href = f.getAttribute('data-dv-go') + (q ? '?q=' + encodeURIComponent(q) : '');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dv-reveal]'); if (!b) return;
    var sec = b.closest('section'); if (!sec) return;
    sec.querySelectorAll('.ar-more-item[hidden]').forEach(function (x) { x.hidden = false; });
    var foot = b.closest('.foot'); if (foot) foot.remove(); else b.remove();
  });
})();
